// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22QUq","title":"Header_title__2NE4-","left":"Header_left__2Pdho","clinicName":"Header_clinicName__2CeNI"};